document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('[data-recipe-trigger]');
  let activeModal = null;
  let lastFocusedTrigger = null;

  function openModal(modal, trigger) {
    if (!modal) return;
    activeModal = modal;
    lastFocusedTrigger = trigger || null;

    modal.setAttribute('data-open', '');
    modal.removeAttribute('aria-hidden');
    document.body.classList.add('recipe-modal-open');

    const closeBtn = modal.querySelector('.recipe-modal__close');
    if (closeBtn) closeBtn.focus();

    document.addEventListener('keydown', handleKeydown);
  }

  function closeModal() {
    if (!activeModal) return;

    activeModal.removeAttribute('data-open');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('recipe-modal-open');

    document.removeEventListener('keydown', handleKeydown);

    if (lastFocusedTrigger) lastFocusedTrigger.focus();

    activeModal = null;
    lastFocusedTrigger = null;
  }

  function handleKeydown(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const targetId = trigger.getAttribute('data-recipe-target');
      const modal = document.getElementById(targetId);
      openModal(modal, trigger);
    });
  });

  document.querySelectorAll('[data-recipe-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
});